<input type="text" class="variant-picker-input" />
